import httpUtils from '../../utils/HttpUtils'

class ProductService {

  async list(categoryId = '',shopId, type = '1',isIndex = '', pageNo = 1) {
    let result = null;
    try {
      result = await httpUtils.post('/mall/product/list', {categoryId, shopId,type , isIndex, pageNo})
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result
  }


  async detail(id){
    let result = null;
    try {
      result = await httpUtils.post('/mall/product/detail', {id});
    } catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result;
  }

  async categoryList(){
    let result = null;
    try {
      result = await httpUtils.post("/mall/product/category/list");
    }catch (error) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'};
    }
    return result;
  }
  async brandList(categoryId = ""){
    let result = null;
    try {
      result = await httpUtils.get("/product/brand/list", {categoryId})
      console.info("品牌=-=========", result)
    }catch (error) {
      throw new Error(error)
    }
    return result.data;
  }
}
export default new ProductService()
